'use strict';
import angular from 'angular';

export const AppConfig = {
    ROOT_URL: window.location.pathname, /* /client/analytics/{ENV_MODE}/ */
    CORE_URL: '/client/core/',
    MAGE_URL: '/app/dash/',
    API_URL: '/server/api/',
    IO_URL: '/client/iotool/dist/',
    IO_CLIENT_URL: '/client/ioclient/dist/',
    TA_URL: '/client/analytics/dist/',
    TA_PRE_URL: '/client/analytics/',
    IO_API_URL: '/app/iotool/',
    API_JSON_URL: '/client/iotool/app/data/',
    API_DEV_URL: '',
    ENV : 'dev'
};

export const FusionSevenConfig = {
    ORG_ID: '1aab2e8a-db03-11e9-9725-06858dc5c004',
    API_KEY: '3206e8f3db0311e9972506858dc5c004'
};

export const AppLoader = {
    SHOW: 'AppLoader:SHOW',
    HIDE: 'AppLoader:HIDE',
};

angular.module('app.constants', [])
    .constant('AppConfig', AppConfig)
    .constant('AppLoader', AppLoader)
    .constant('FusionSevenConfig', FusionSevenConfig);
